import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { toggleSwitch } from '../../actions/index';
import { _ } from '../../functions/translator.js';
import Switch from '@material-ui/core/Switch';
import InfoTooltip from '../infoTooltip/infoTooltip.js';
import { ToggleActions } from '../../constants/constants.js';

class TimelineTitle extends React.Component {

    handleOnClick = () => {
        this.props.toggleSwitch(ToggleActions.PLANNED_TIMELINE)
    }

    render() {
        let title = this.props.plannedTimeline ? _('Avance Planificado') : _('Avance Temporal')

        return(
            <div>
                <p className="text timeslider-element timeslider-header">
                    {title + ' '}  
                    <Switch
                        checked={this.props.plannedTimeline}
                        onChange={this.handleOnClick}
                        color="primary"
                        size="small"
                    />
                    <InfoTooltip message={'timeline message'}/>
                </p>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        plannedTimeline : state.switches.plannedTimeline,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch    : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(TimelineTitle);